import { __assign, __rest } from "tslib";
import { FirstSvg, StyledInput } from "./styles";
import { Input } from "reactstrap";
import { FaSearch, FaTimes } from "react-icons/fa";
import React from "react";
export var IconInput = function (_a) {
    var placeholder = _a.placeholder, color = _a.color, icon = _a.icon, value = _a.value, type = _a.type, isClearable = _a.isClearable, onChange = _a.onChange, deleteButton = _a.deleteButton, containerStyles = _a.containerStyles, inputStyles = _a.inputStyles, deleteIcon = _a.deleteIcon, disabled = _a.disabled, rest = __rest(_a, ["placeholder", "color", "icon", "value", "type", "isClearable", "onChange", "deleteButton", "containerStyles", "inputStyles", "deleteIcon", "disabled"]);
    return (React.createElement(StyledInput, { style: containerStyles, color: color, disabled: disabled },
        React.createElement(FirstSvg, null, icon || React.createElement(FaSearch, null)),
        React.createElement(Input, __assign({ type: type, style: inputStyles, placeholder: placeholder, value: value, onChange: onChange }, rest)),
        isClearable && (React.createElement("div", { style: { cursor: "pointer" }, color: color || "#f7c3ca", onClick: function () {
                if (deleteButton) {
                    deleteButton();
                }
            } }, deleteIcon || React.createElement(FaTimes, null)))));
};
//# sourceMappingURL=index.js.map